import React, {useEffect, useRef} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { listPlaylistVideos } from '../../actions/PlaylistActions'
import { useParams } from 'react-router-dom'
import arrowLeft from '../icons/Arrow_left.svg'
import { useNavigate, useNavigationType } from 'react-router-dom';
import default_cover from '../images/default_cover.jpg'
import { formatSeconds } from '../../utils/formatTime'
import Play_All from '../icons/PLAY_ALL.svg'


const PlaylistPage = () => {

    const {playlist_id, playlist_title} = useParams()

    const dispatch = useDispatch()

    const navigate = useNavigate()

    const navigationType = useNavigationType();

    const playlistPageRef = useRef(null);

    const { loading, playlistVideos } = useSelector(state => state.userPlaylists)

    useEffect(()=>{
        localStorage.setItem("path", `/playlist/${playlist_id}/${playlist_title}`)

        dispatch(listPlaylistVideos(playlist_id))

        window.scrollTo(0, 0)

    },[dispatch, playlist_id])



    const get_members = (data) =>{
        let members = ''

        if (data.artists && data.artists.length){
          members = data.artists
      }

      if (data.composers && data.composers.length){
          let c = data.composers.split(',')
          for (let i in c){
              if (!members.includes(c[i])){
                  members += ', '+ c[i]
              }
          }
      }
        return members
    }

    useEffect(()=>{
        if(playlistVideos && playlistVideos.length && navigationType === "POP"){
            playlistPageRef.current.scrollTo({
                top: sessionStorage.getItem("results-scroll") || 0,
                behavior: "auto"
            })
        }
    },[playlistVideos])

    const clickHandler = (video) => {
        let group_id = localStorage.getItem('group_id')
        localStorage.setItem('video_id', video.id)
        localStorage.setItem('playlist_id', playlist_id)
        navigate(encodeURI(`/home?g=${group_id}&p=${playlist_id}&v=${video.id}`, {replace: false} ))
    }


    const playallClickHandler = () => {
        let group_id = localStorage.getItem('group_id')
        if (playlistVideos && playlistVideos.length){
            let first_video = playlistVideos[0]
            localStorage.setItem('video_id', first_video.id)
            localStorage.setItem('playlist_id', playlist_id)
            navigate(encodeURI(`/home?g=${group_id}&p=${playlist_id}&v=${first_video.id}`, {replace: false} ))
        }
    }

    const handleScroll = event => {

        const {scrollTop, clientHeight, scrollHeight} = event.currentTarget;
        sessionStorage.setItem("results-scroll", scrollTop);

      }


      return (
        <div className = "w-100 bg-bluedark d-flex flex-column align-items-center page-bg-fill">
        <div className = "w-100 d-flex flex-column align-items-center"
            style={{maxHeight:"calc(100vh - 5rem)"}}
        >
        {
            loading ? <div className = "text-info col-12 col-lg-10" >Loading...</div> :
            <>
                <div className = 'w-100 pt-3 pt-md-5 pb-2 d-flex justify-content-center'>
                    <div className = "col-12 col-lg-10 d-flex flex-column flex-md-row justify-content-center align-items-start">
                        <div className = 'col-12 col-md-6 px-3 px-md-5 d-flex align-items-center justify-content-start'>
                            <img
                                src = {arrowLeft}
                                role = 'button'
                                onClick={()=>navigate(-1)}
                                alt = ''
                                className='flex-shrink-0'
                                style={{height:"17px", width:"auto"}}
                                />
                            <div className='ps-3 text-white fs-7 page-title text-truncate flex-grow-1'
                                style={{minWidth:0}}
                                title={playlist_title}
                            >{playlist_title}</div>
                            <img
                                className='ps-3 flex-shrink-0'
                                src = {Play_All}
                                role = 'button'
                                onClick={()=>playallClickHandler()}
                                alt = ''
                                style={{height:"28px", width:"auto"}}
                            />
                        </div>
                        <div className='col-12 col-md-6 d-flex px-2 px-md-5 justify-content-end'>
                            {
                                playlistVideos && playlistVideos.length ?
                                <>
                                    <div className = "text-info px-3 text-nowrap">{playlistVideos.length} Videos</div>
                                    <div className = "text-info px-3 border-start border-info text-nowrap">{formatSeconds(playlistVideos.reduce((sum, item) => sum + item.duration, 0))} </div>

                                </>: ""
                            }
                        </div>
                    </div>
                </div>
                <div className='col-12 col-lg-10 px-4 d-flex flex-row flex-wrap results-wrapper'
                    ref={playlistPageRef}
                    onScroll = {handleScroll}>
                    {
                        playlistVideos && playlistVideos.length ?
                        playlistVideos.map((video)=>(
                            <div key = {video.id}
                                className = "col-6 col-md-4 col-lg-3 px-1 py-2 d-flex align-items-start"
                                onClick={()=>clickHandler(video)}
                                >
                                <div className='w-100' >
                                    <div className='position-relative'
                                    >
                                        <img src={ `https://img.cugate.com/?o=CUTV_VIDEO&i=${video.id}&s=300`} alt = ""
                                            onError = {({ currentTarget }) => {
                                                currentTarget.onerror = null // prevents looping
                                                currentTarget.src=default_cover
                                            }}
                                            role='button'
                                            className='w-100 px-1'
                                            style={
                                                {
                                                    objectFit: 'cover',
                                                    borderRadius:'0.625vw',
                                                    aspectRatio: "16/9"
                                                }
                                            }>
                                            </img>
                                            <div className='position-absolute text-white rounded px-1 bg-dark'
                                                style={{zIndex:"2", bottom:"0.05rem", right:"0.2rem"}}>
                                                {formatSeconds(video.duration)}
                                            </div>
                                    </div>
                                    <div className = "w-100 d-flex flex-row align-items-start pt-1 pt-lg-3">
                                        <div
                                            className='ms-0 w-100 ms-lg-3 text-wrap px-1 d-flex flex-column'
                                            >
                                            <h6
                                                className='text-white grid-item-title overflow-hidden m-0'
                                                // style={{height:"auto"}}
                                                title={video.title}>{video.title}</h6>
                                                {
                                                    get_members(video).length ?
                                                    <h6
                                                        className='text-info overflow-hidden'
                                                        style={{maxHeight:'40px'}}
                                                        title={get_members(video)}>{get_members(video)}</h6> : ""
                                                }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )) : ""
                    }
                </div>
            </>
        }
        </div>

        </div>
    );
};

export default PlaylistPage;